





























































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { AppConstants as _app } from "@/shared/app.constants.ts";
import DashboardFilterComponent from "./Filter/DashboardFilter.vue";
import { http } from "@/shared/https";
import Axios from "axios";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

@Component({
  components: {
    DashboardFilterComponent
  }
})
export default class InternalReviewerDashboardComponent extends Vue {

  @Action("create", { namespace: "assessmentForm" }) createReview: any;
  @Action("setReviewId", { namespace: "assessmentForm" }) setReview: any;

  reviewAllowedStatus = _app.internalReviewAllowedStatus;
  collapsed = false;
  countLoop: number = 0;
  dataLength: number = 0;
  reviews: Array<any> = [];
  defaultData: Array<any> = [];
  uploadReady: boolean = true;
  readonlyStatus = [_app.reviewStatus.COI_Rejected, _app.reviewStatus.Internal_Submitted];
  inProgressStatus = [_app.reviewStatus.Internal_In_Progress];
  items: Array<any> = [];

  mounted() {
    this.getFilter();
  }

  getFilter() {
    this.items = this.$services.reviewinternal.getFilter();
  }

  collapseFilter() {
    this.collapsed = !this.collapsed;
  }

  /** List reviews on page load */
  listProposal() {
    return this.$services.reviewinternal.listProposal();
  }

  /** Start review of the application */
  startReview(item) {
    var self = this;
  
    if(item.InternalReviewId){
      this.setReview(item.InternalReviewId)
      this.$router.push({
        name: "internalReviewSummary"
      });
    }
    else {
    self.createReview({ ApplicationId: item.ApplicationId })
      .then((data: any) => {
        if(data && data.InternalReviewId) {
          this.setReview(data.InternalReviewId);
          this.$router.push({
            name: "internalReviewSummary"
          });
        }
      });
    }
  }
  /*List reviews*/
  listReviews(e) {
    let filteredData = '';
    var self = this;
    http.get(`/api/ReviewInternal?${e}`).then((resp: any) => {
      if (resp.data && resp.data.Items) {
        self.reviews = resp.data.Items;
      }
      if(resp.data.Filters != null){
        filteredData = JSON.stringify(resp.data.Filters);
      }      
      let initialFilter = JSON.stringify(self.items);
      if(filteredData && filteredData !== initialFilter){
        self.items = resp.data.Filters;
      }
    });
  }

  /** Delete Proposal*/
  deleteProposal() {}

  /** watch method */
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if(changedRoute && changedRoute.name === 'internalReviews') {
      this.listProposal().then((data: any) => {
        this.reviews = data;
        // console.log(data);
      });
    }
  }
}
